<template>
  <question-card @submit="submit" :buttonText="UIComponentData.Button.Translations[questionnaireLead.Language]">
    <template #title>
      {{UIComponentData.Header.Translations[questionnaireLead.Language]}}

    </template>
    <div>
        <v-text-field
        autofocus
        outlined
          v-model="monthlyPayment"
          ref="input"
          :label="UIComponentData.InputPlaceholder1.Translations[questionnaireLead.Language]"
          required
          type="numeric"
          inputmode="numeric"
      />
    </div>
  </question-card>
</template>

<script>
import { mapActions,mapGetters } from 'vuex';
import QuestionCard from '@/components/QuestionCard.vue';

export default {
  name: 'monthly-payment-step',
  components: {
    QuestionCard,
  },
  methods: {
    ...mapActions(['mutateLead']),
    async submit() {
      if(this.UIId!=null){
        if(this.questionnaireLead.StepId==null||this.UIId > this.questionnaireLead.StepId){
          this.questionnaireLead.StepId = this.UIId
          this.mutateLead(this.questionnaireLead);
          this.$emit('route-to-next-slide',true);
        }
        else{
          this.$emit('route-to-next-slide',false);
        }
      }
    },
  },
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
    UIId: Number
  },
  computed: {
    ...mapGetters(['questionnaireLead']),
    monthlyPayment:{
      get(){
        return this.questionnaireLead.MonthlyPayment?
        '$'+parseInt(this.questionnaireLead.MonthlyPayment).toLocaleString('en-US', { style: 'decimal', currency: 'USD' })
        :''
      },
      set(value){
        this.questionnaireLead.MonthlyPayment=value.replace(/[^0-9]/g, '')
      }
    }
  },
  mounted() {
    this.$refs.input.$el.focus();
  },
  created(){
    if(!this.questionnaireLead.MonthlyPayment)
      this.$set(this.questionnaireLead, 'MonthlyPayment','');
  }
};
</script>
